export default {
  allVehicleModels: [],
  vehicleModel: {},
}
